'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  border-collapse: collapse;\n\n  @media screen and (max-width: 600px) {\n    thead {\n      border: none;\n      clip: rect(0 0 0 0);\n      height: 1px;\n      margin: -1px;\n      overflow: hidden;\n      padding: 0;\n      position: absolute;\n      width: 1px;\n    }\n    tr {\n      border-bottom: 3px solid ', ';\n      display: block;\n      margin-bottom: .625em;\n    }\n  }\n'], ['\n  width: 100%;\n  border-collapse: collapse;\n\n  @media screen and (max-width: 600px) {\n    thead {\n      border: none;\n      clip: rect(0 0 0 0);\n      height: 1px;\n      margin: -1px;\n      overflow: hidden;\n      padding: 0;\n      position: absolute;\n      width: 1px;\n    }\n    tr {\n      border-bottom: 3px solid ', ';\n      display: block;\n      margin-bottom: .625em;\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 55px;\n  border-radius: 55px;\n  background-color: ', ';\n  box-shadow: 0 10px 18px -12px ', ';\n  color: ', ';\n  display: ', ';\n\n  & > tr {\n    height: 55px;\n  }\n'], ['\n  width: 100%;\n  height: 55px;\n  border-radius: 55px;\n  background-color: ', ';\n  box-shadow: 0 10px 18px -12px ', ';\n  color: ', ';\n  display: ', ';\n\n  & > tr {\n    height: 55px;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 55px;\n  color: ', ';\n'], ['\n  width: 100%;\n  height: 55px;\n  color: ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  padding: .35em;\n'], ['\n  padding: .35em;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  padding: 0.925em;\n  text-align: left;\n  letter-spacing: .1em;\n  line-height: 2em;\n  text-transform: uppercase;\n  color: ', ';\n  &:first-child {\n    border-radius: 55px 0 0 55px;\n  }\n\n  &:last-child {\n    border-radius: 0 55px 55px 0;\n  }\n'], ['\n  padding: 0.925em;\n  text-align: left;\n  letter-spacing: .1em;\n  line-height: 2em;\n  text-transform: uppercase;\n  color: ', ';\n  &:first-child {\n    border-radius: 55px 0 0 55px;\n  }\n\n  &:last-child {\n    border-radius: 0 55px 55px 0;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  color: ', ';\n'], ['\n  color: ', ';\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  width: 100%;\n  display: ', ';\n'], ['\n  width: 100%;\n  display: ', ';\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  border-bottom: 1px solid ', ';\n  padding: .35em;\n}'], ['\n  border-bottom: 1px solid ', ';\n  padding: .35em;\n}']),
    _templateObject9 = _taggedTemplateLiteral(['\n  border-bottom: 1px solid ', ';\n  padding: .35em;\n\n  &:hover {\n    border-bottom: 1px solid ', ';\n    background-color: rgb(255, 255, 255);\n    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    box-sizing: border-box;\n    font-family: Roboto, sans-serif;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    box-shadow: ', ' 0px 1px 6px, ', ' 1px 9px 20px 0px;\n  }\n'], ['\n  border-bottom: 1px solid ', ';\n  padding: .35em;\n\n  &:hover {\n    border-bottom: 1px solid ', ';\n    background-color: rgb(255, 255, 255);\n    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    box-sizing: border-box;\n    font-family: Roboto, sans-serif;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    box-shadow: ', ' 0px 1px 6px, ', ' 1px 9px 20px 0px;\n  }\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  padding: .35em;\n  text-align: left;\n'], ['\n  padding: .35em;\n  text-align: left;\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  margin: 7em;\n  text-align: left;\n'], ['\n  margin: 7em;\n  text-align: left;\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  display: block;\n  min-width: 6em;\n  color: ', '\n'], ['\n  display: block;\n  min-width: 6em;\n  color: ', '\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  width: 100%;\n  margin: 1em;\n  display: block;\n'], ['\n  width: 100%;\n  margin: 1em;\n  display: block;\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n  width: 100%;\n  padding: 1em;\n  margin: 1em;\n'], ['\n  width: 100%;\n  padding: 1em;\n  margin: 1em;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

var _MozartButton = require('../MozartButton');

var _MozartButton2 = _interopRequireDefault(_MozartButton);

var _MozartIcon = require('../MozartIcon');

var _MozartIcon2 = _interopRequireDefault(_MozartIcon);

var _ramda = require('ramda');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Table = _styledComponents2.default.table(_templateObject, _color2.default.grey_accent_1);

var TableHead = _styledComponents2.default.thead(_templateObject2, _color2.default.blue_main, _color2.default.grey_main, _color2.default.white, function (props) {
  return props.isFireFox ? 'block' : 'table-row-group';
});

var TableHeadLight = _styledComponents2.default.thead(_templateObject2, _color2.default.purple_main, _color2.default.grey_main, _color2.default.blue_accent, function (props) {
  return props.isFireFox ? 'inherit' : 'table-row-group';
});

var TableHeadClassic = _styledComponents2.default.thead(_templateObject3, _color2.default.blue_main);

var TableHeadRow = _styledComponents2.default.tr(_templateObject4);

var TableHeadCol = _styledComponents2.default.th(_templateObject5, function (props) {
  return props.isLight ? _color2.default.blue_accent : _color2.default.white;
});

var TableHeadColClassic = _styledComponents2.default.th(_templateObject6, _color2.default.blue_main);

var TableBody = _styledComponents2.default.tbody(_templateObject7, function (props) {
  return props.isFireFox ? 'block' : 'table-row-group';
});

var TableBodyRowNoHover = _styledComponents2.default.tr(_templateObject8, _color2.default.grey_accent_1);

var TableBodyRow = _styledComponents2.default.tr(_templateObject9, _color2.default.grey_accent_1, _color2.default.orange_main, _color2.default.purple_accent, _color2.default.purple_accent);

var TableBodyCol = _styledComponents2.default.td(_templateObject10);

var NoData = _styledComponents2.default.div(_templateObject11);

var ActionContainer = _styledComponents2.default.div(_templateObject12, _color2.default.blue_accent);

var ActionItem = _styledComponents2.default.div(_templateObject13);

var Accordion = _styledComponents2.default.div(_templateObject14);

var getElemDistance = function getElemDistance(elem) {
  var location = 0;
  if (elem.offsetParent) {
    do {
      location += elem.offsetTop;
      elem = elem.offsetParent;
    } while (elem);
  }
  return location >= 0 ? location : 0;
};

var MozartTable = function (_Component) {
  _inherits(MozartTable, _Component);

  function MozartTable(props) {
    _classCallCheck(this, MozartTable);

    var _this = _possibleConstructorReturn(this, (MozartTable.__proto__ || Object.getPrototypeOf(MozartTable)).call(this, props));

    _this.state = {
      sticky_pos: ''
    };
    _this.lastScrollPosition = '';
    _this.onScroll = (0, _utils.throttle)(_this.stickyHeader.bind(_this), 600);
    return _this;
  }

  _createClass(MozartTable, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.sticky) {
        this.setState({
          // distance form the elem to top of page ( not viewport )
          sticky_pos: getElemDistance(document.getElementById(this.props.headerId))
        }, function () {
          window.addEventListener('scroll', _this2.onScroll, false);
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.sticky) {
        window.removeEventListener('scroll', this.onScroll, false);
      }
    }
  }, {
    key: 'checkData',
    value: function checkData() {
      var rows = this.props.rows;

      var check = true;
      if (rows && rows.length === 0) {
        check = false;
      }
      return check;
    }
  }, {
    key: 'renderNoData',
    value: function renderNoData() {
      var check = this.checkData();
      var noDataCustomeMessage = this.props.noDataCustomeMessage;

      if (!check) {
        if (noDataCustomeMessage) {
          return _react2.default.createElement(
            NoData,
            { 'data-theme': 'NoDataAvailable' },
            _react2.default.createElement(
              'p',
              null,
              noDataCustomeMessage
            )
          );
        }
        return _react2.default.createElement(
          NoData,
          { 'data-theme': 'NoDataAvailable' },
          _react2.default.createElement(_MozartIcon2.default, {
            backgroundColor: _color2.default.purple_accent,
            style: { width: '5em', height: '5em', paddingTop: '1em', border: 'none' },
            data: _react2.default.createElement('span', { style: { fontSize: '3em' }, className: 'icon-Information' })
          }),
          _react2.default.createElement(
            'h3',
            null,
            'No Results Found'
          ),
          _react2.default.createElement(
            'p',
            null,
            'There are no records to show you right now. there may be no entries or your filters may be too tightly defined.'
          )
        );
      }
    }

    // if the scroll position is bigger than the elmen position and user scrolling down we trigger sticky header

  }, {
    key: 'stickyHeader',
    value: function stickyHeader() {
      var header = document.getElementById(this.props.headerId + '_sticky');
      // scroll position
      var newScrollPosition = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

      if (this.props.sticky && header !== null) {
        // if scroll position > elem position to top of page
        if (window.pageYOffset >= this.state.sticky_pos) {
          // if new scroll position < last scroll pos
          if (newScrollPosition < this.lastScrollPosition) {
            header.style.top = this.props.scrollUpPos;
            header.style.visibility = 'hidden';
          } else {
            header.style.top = '0';
            header.style.display = 'inherit';
            header.style.visibility = 'inherit';
            header.style.position = 'fixed';
            header.style['border-radius'] = '0';
            header.style['z-index'] = this.props.headerZIndex;
            header.style.left = '0';
            header.querySelector('tr').style.width = '100%';
            header.querySelector('tr').style.position = 'fixed';
          }
        } else {
          header.style.top = this.props.scrollUpPos;
          header.style.visibility = 'hidden';
        }
        this.lastScrollPosition = newScrollPosition;
      }
    }
  }, {
    key: 'renderHeadersLight',
    value: function renderHeadersLight() {
      var _props = this.props,
          onAddButton = _props.onAddButton,
          mainHeaderStyle = _props.mainHeaderStyle,
          headerStyle = _props.headerStyle,
          fixedHeaderStyle = _props.fixedHeaderStyle,
          onDuplicateButton = _props.onDuplicateButton,
          onDeleteButton = _props.onDeleteButton,
          onEditButton = _props.onEditButton;
      var _props2 = this.props,
          headerId = _props2.headerId,
          headers = _props2.headers,
          headStyle = _props2.headStyle;

      var isFireFox = (0, _utils.checkBrowser)() === 'firefox';
      var DATA = headers.map(function (header, index) {
        return _react2.default.createElement(
          TableHeadCol,
          { isLight: true, key: index, style: headerStyle && headerStyle[index] ? Object.assign(headerStyle[index], headStyle) : headStyle },
          header
        );
      });
      var FIXEDDATA = headers.map(function (header, index) {
        return _react2.default.createElement(
          TableHeadCol,
          { isLight: true, key: index, style: fixedHeaderStyle && fixedHeaderStyle[index] ? Object.assign(fixedHeaderStyle[index], headStyle) : headStyle },
          header
        );
      });

      if (onAddButton || onDeleteButton || onEditButton || onDuplicateButton) {
        DATA.push(_react2.default.createElement(TableHeadCol, null));
        FIXEDDATA.push(_react2.default.createElement(TableHeadCol, null));
      }
      return [_react2.default.createElement(
        TableHeadLight,
        { style: mainHeaderStyle, isFireFox: isFireFox, key: 1, id: headerId },
        _react2.default.createElement(
          TableHeadRow,
          null,
          DATA
        )
      ), _react2.default.createElement(
        TableHeadLight,
        { style: mainHeaderStyle ? Object.assign(Object.assign({}, mainHeaderStyle), { display: 'none' }) : { display: 'none' }, isFireFox: isFireFox, key: 2, id: headerId + '_sticky' },
        _react2.default.createElement(
          TableHeadRow,
          null,
          FIXEDDATA
        )
      )];
    }
  }, {
    key: 'renderHeadersDark',
    value: function renderHeadersDark() {
      var _props3 = this.props,
          onAddButton = _props3.onAddButton,
          mainHeaderStyle = _props3.mainHeaderStyle,
          headerStyle = _props3.headerStyle,
          fixedHeaderStyle = _props3.fixedHeaderStyle,
          onDuplicateButton = _props3.onDuplicateButton,
          onDeleteButton = _props3.onDeleteButton,
          onEditButton = _props3.onEditButton;
      var _props4 = this.props,
          headerId = _props4.headerId,
          headers = _props4.headers,
          headStyle = _props4.headStyle;

      var isFireFox = (0, _utils.checkBrowser)() === 'firefox';
      var DATA = headers.map(function (header, index) {
        return _react2.default.createElement(
          TableHeadCol,
          { key: index, style: headerStyle && headerStyle[index] ? Object.assign(headerStyle[index], headStyle) : headStyle },
          header
        );
      });
      var FIXEDDATA = headers.map(function (header, index) {
        return _react2.default.createElement(
          TableHeadCol,
          { key: index, style: fixedHeaderStyle && fixedHeaderStyle[index] ? Object.assign(fixedHeaderStyle[index], headStyle) : headStyle },
          header
        );
      });

      if (onAddButton || onDeleteButton || onEditButton || onDuplicateButton) {
        DATA.push(_react2.default.createElement(TableHeadCol, null));
        FIXEDDATA.push(_react2.default.createElement(TableHeadCol, null));
      }
      return [_react2.default.createElement(
        TableHead,
        { style: mainHeaderStyle, isFireFox: isFireFox, key: 1, id: headerId },
        _react2.default.createElement(
          TableHeadRow,
          null,
          DATA
        )
      ), _react2.default.createElement(
        TableHead,
        { style: mainHeaderStyle ? Object.assign(Object.assign({}, mainHeaderStyle), { display: 'none' }) : { display: 'none' }, isFireFox: isFireFox, key: 2, id: headerId + '_sticky' },
        _react2.default.createElement(
          TableHeadRow,
          null,
          FIXEDDATA
        )
      )];
    }
  }, {
    key: 'renderHeadersClassic',
    value: function renderHeadersClassic() {
      var _props5 = this.props,
          onAddButton = _props5.onAddButton,
          onDeleteButton = _props5.onDeleteButton,
          onEditButton = _props5.onEditButton,
          onDuplicateButton = _props5.onDuplicateButton;
      var _props6 = this.props,
          headerId = _props6.headerId,
          headers = _props6.headers,
          headStyle = _props6.headStyle;

      var isFireFox = (0, _utils.checkBrowser)() === 'firefox';

      var DATA = headers.map(function (header, index) {
        return _react2.default.createElement(
          TableHeadColClassic,
          { key: index, style: headStyle },
          header
        );
      });
      if (onAddButton || onDeleteButton || onEditButton || onDuplicateButton) {
        DATA.push(_react2.default.createElement(TableHeadColClassic, null));
      }
      return [_react2.default.createElement(
        TableHeadClassic,
        { isFireFox: isFireFox, key: 1, id: headerId },
        _react2.default.createElement(
          TableHeadRow,
          null,
          DATA
        )
      )];
    }
  }, {
    key: 'renderHeaders',
    value: function renderHeaders() {
      var _props7 = this.props,
          theme = _props7.theme,
          headers = _props7.headers,
          headStyle = _props7.headStyle;

      var isClassic = theme && theme === 'classic';
      var isLight = theme && theme === 'light';
      if (isLight) {
        return this.renderHeadersLight(headers, headStyle);
      }
      if (isClassic) {
        return this.renderHeadersClassic(headers, headStyle);
      }
      return this.renderHeadersDark(headers, headStyle);
    }
  }, {
    key: 'renderButton',
    value: function renderButton(index, label, iconName, func) {
      var icon = _react2.default.createElement('span', { className: 'icon-' + iconName });
      var onClick = func ? func.bind(this, index) : undefined;

      var renderActionContainer = function renderActionContainer(button) {
        return _react2.default.createElement(
          ActionItem,
          null,
          button
        );
      };
      var renderActionButton = function renderActionButton(icon) {
        return function (label, onClick) {
          return _react2.default.createElement(_MozartButton2.default, { data: label, onClick: onClick, icon: icon });
        };
      };
      var renderButton = (0, _ramda.compose)(renderActionContainer, renderActionButton(icon));

      return func ? renderButton(label, onClick) : '';
    }
  }, {
    key: 'renderActions',
    value: function renderActions(rowindex) {
      var _props8 = this.props,
          onAddButton = _props8.onAddButton,
          onDeleteButton = _props8.onDeleteButton,
          onEditButton = _props8.onEditButton,
          onDuplicateButton = _props8.onDuplicateButton;


      return _react2.default.createElement(
        ActionContainer,
        null,
        this.renderButton(rowindex, 'Edit', 'Edit', onEditButton),
        this.renderButton(rowindex, 'Add', 'Add', onAddButton),
        this.renderButton(rowindex, 'Delete', 'Delete', onDeleteButton),
        this.renderButton(rowindex, 'Duplicate', 'Copy', onDuplicateButton)
      );
    }
  }, {
    key: 'renderAccordion',
    value: function renderAccordion(rowindex) {
      var accordion = this.props.accordion;

      return accordion ? _react2.default.createElement(
        Accordion,
        { ref: 'row_' + rowindex },
        accordion[rowindex]
      ) : '';
    }
  }, {
    key: 'renderRows',
    value: function renderRows() {
      var _this3 = this;

      var _props9 = this.props,
          onAddButton = _props9.onAddButton,
          onDeleteButton = _props9.onDeleteButton,
          onEditButton = _props9.onEditButton,
          onDuplicateButton = _props9.onDuplicateButton;
      var _props10 = this.props,
          theme = _props10.theme,
          accordion = _props10.accordion,
          rows = _props10.rows,
          bodyStyle = _props10.bodyStyle,
          rowStyle = _props10.rowStyle,
          colStyle = _props10.colStyle,
          colsStyle = _props10.colsStyle,
          _onClick = _props10.onClick;

      var isFireFox = (0, _utils.checkBrowser)() === 'firefox';
      var isClassic = theme && theme === 'classic';

      var DATA = [];
      var cursorStyle = _onClick ? { cursor: 'pointer' } : {};
      rows.forEach(function (row, rowindex) {
        var getColStyle = function getColStyle(index) {
          return colsStyle && colsStyle[index] ? Object.assign(colsStyle[index], Object.assign(cursorStyle, colStyle)) : Object.assign(cursorStyle, colStyle);
        };
        var cols = row.map(function (col, colindex) {
          return _react2.default.createElement(
            TableBodyCol,
            { onClick: function onClick() {
                if (_onClick) {
                  _onClick(rowindex);
                }
              }, key: rowindex + '-' + colindex, style: getColStyle(colindex) },
            col
          );
        });
        if (onAddButton || onDeleteButton || onEditButton || onDuplicateButton) {
          cols.push(_react2.default.createElement(
            TableBodyCol,
            { key: rowindex + '- action', style: Object.assign(cursorStyle, colStyle) },
            _this3.renderActions(rowindex)
          ));
        }

        var rowdata = _react2.default.createElement(
          TableBodyRow,
          { key: rowindex, style: rowStyle },
          cols
        );
        var rownohoverdata = _react2.default.createElement(
          TableBodyRowNoHover,
          { key: rowindex, onClick: function onClick() {
              if (_onClick) {
                _onClick(rowindex);
              }
            }, style: rowStyle },
          cols
        );
        var accordiondata = _this3.renderAccordion(rowindex);
        DATA.push(_onClick && cols.length > 1 ? rowdata : rownohoverdata);
        if (accordion) {
          DATA.push(accordiondata);
        }
      });
      return _react2.default.createElement(
        TableBody,
        { isFireFox: isFireFox && !isClassic, style: bodyStyle },
        DATA
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props11 = this.props,
          headers = _props11.headers,
          rows = _props11.rows,
          style = _props11.style,
          themeId = _props11.themeId;

      return _react2.default.createElement(
        'div',
        { 'data-qa': this.props.testId, 'data-theme': themeId },
        _react2.default.createElement(
          Table,
          { style: style },
          headers ? this.renderHeaders() : '',
          rows ? this.renderRows() : ''
        ),
        this.renderNoData()
      );
    }
  }]);

  return MozartTable;
}(_react.Component);

MozartTable.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** style override */
  style: _propTypes2.default.object,
  /** style for fixed header each column override */
  fixedHeaderStyle: _propTypes2.default.array,
  /** theme classic or dark or light */
  theme: _propTypes2.default.string,
  /** style for whole header override */
  mainHeaderStyle: _propTypes2.default.object,
  /** style for header each column override */
  headerStyle: _propTypes2.default.array,
  /** header style */
  headStyle: _propTypes2.default.object,
  /** body style */
  bodyStyle: _propTypes2.default.object,
  /** row style */
  rowStyle: _propTypes2.default.object,
  /** each column style */
  colsStyle: _propTypes2.default.array,
  /** col style */
  colStyle: _propTypes2.default.object,
  /** headers array */
  headers: _propTypes2.default.array,
  /** rows array */
  rows: _propTypes2.default.array,
  /** accordion array */
  accordion: _propTypes2.default.array,
  /** if true header position will be fixed */
  sticky: _propTypes2.default.bool,
  /** top position of header when scroll up */
  scrollUpPos: _propTypes2.default.string,
  /** z index for header */
  headerZIndex: _propTypes2.default.number,
  /** no data custom message */
  noDataCustomeMessage: _propTypes2.default.string,
  /** on click callback */
  onClick: _propTypes2.default.func,
  /** on duplicate button callback last column */
  onDuplicateButton: _propTypes2.default.func,
  /** on add button callback last column */
  onAddButton: _propTypes2.default.func,
  /** on delete button callback last column */
  onDeleteButton: _propTypes2.default.func,
  /** on edit button callback last column */
  onEditButton: _propTypes2.default.func
};
MozartTable.defaultProps = {
  testId: 'MozartTable',
  themeId: 'MozartTable',
  headerId: 'mozart_table_header_id',
  scrollUpPos: '10em',
  sticky: false,
  headerZIndex: 100
};
exports.default = MozartTable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartTable/MozartTable.js
// module id = 1832
// module chunks = 1